//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import Select from 'react-select';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import { withTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class FilterSelector extends React.Component {
  render() {
    const {
      className,
      title,
      custom,
      onFocus = () => {},
      t,
      ...props
    } = this.props;
    const componentClasses = classNames(styles.FilterSelector, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        {custom || (
          <Select
            onFocus={() => onFocus()}
            classNamePrefix="filter-select"
            aria-label={t('dashboard_FilterSelector')}
            isSearchable={false}
            formatOptionLabel={({ label }, { context }) => {
              const isValue = context === 'value';

              const optionClasses = classNames(styles.OptionLabel, {
                [styles.Value]: isValue,
              });

              return (
                <div className={optionClasses}>
                  {isValue && (
                    <span className={styles.SelectorTitle}>{title}</span>
                  )}
                  <span className={styles.Label}>{label}</span>
                </div>
              );
            }}
            {...props}
          />
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(FilterSelector);
